import { CrewDocument } from '../Crew/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { ShiftDocument } from '../Shifts/queryBuilder';
import { AssignmentDocument, assignmentPullQueryBuilder } from './queryBuilder';

export function assignmentFamilyMember(
  configBuilder: ConfigBuilder,
  crew: FamilyMember<CrewDocument>,
  shift: FamilyMember<ShiftDocument>,
): FamilyMember<AssignmentDocument> {
  const syncConfig = configBuilder<AssignmentDocument>(RxdbCollectionNameV2.ASSIGNMENT);
  doNotAutoSync(syncConfig);

  pull(syncConfig, assignmentPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.ASSIGNMENT, replicationState, [crew, shift]);
}
